import { useTheme } from 'foundations-theming-specialty/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BreezeCopilotIcon = ({
  width,
  height,
  title
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsxs("svg", {
    width: width,
    height: height,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [title ? /*#__PURE__*/_jsx("title", {
      children: title
    }) : null, /*#__PURE__*/_jsx("g", {
      clipPath: "url(#clip0_11552_13649)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M15.9751 7.51952C12.2738 7.51952 9.18045 4.32283 9.18045 0.491223C9.18045 0.226213 8.96712 0.00537109 8.71112 0.00537109C8.45512 0.00537109 8.24178 0.226213 8.24178 0.491223C8.24178 4.32283 5.14845 7.51952 1.44712 7.51952C1.18578 7.51952 0.977783 7.74036 0.977783 8.00537C0.977783 8.2759 1.18578 8.49122 1.44712 8.49122C5.14845 8.49122 8.24178 11.6879 8.24178 15.5195C8.24178 15.7845 8.45512 16.0054 8.71112 16.0054C8.96712 16.0054 9.18045 15.7845 9.18045 15.5195C9.18045 11.6879 12.2738 8.49122 15.9751 8.49122C16.2365 8.49122 16.4445 8.27038 16.4445 8.00537C16.4445 7.73484 16.2365 7.51952 15.9751 7.51952Z",
        fill: theme.color['global-shell-icon-copilot-default']
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_11552_13649",
        children: /*#__PURE__*/_jsx("rect", {
          width: "16",
          height: "16",
          fill: "white",
          transform: "translate(0.711121)"
        })
      })
    })]
  });
};